import * as actionTypes from "./customReportsTypes";

const INITIAL_STATE = {
    datasetsList: [],
    datasetColumns: [],
    viewColumns: [],
    reportOutput: null,
    reportPreview: null,
    savedReportsList: [],
    customReportsList: [],
    customReportsPagination: {
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        pageSize: 10
    },
    selectedDataset: null,
    selectedColumns: [],
    reportConfig: null,
    publishedReport: null,
    columnFormatting: null,
    columnFormattingSaving: false,
    reportDetails: null,
    updatedReport: null,
    reportParameters: [],
    reportParametersLoading: false,
    usersForShare: [],
    rolesForShare: [],
    sharedReport: null,
    shareReportSaving: false,
    reportShares: [],
    reportSharesPagination: null,
    updatedReportShare: null,
    updateReportShareSaving: false,
    deletedReportShareId: null,
    deleteReportShareSaving: false,
};

const customReportsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETDATASETSLIST:
            return {
                ...state,
                datasetsList: action.payload.list,
            };
        case actionTypes.SETDATASETCOLUMNS:
            return {
                ...state,
                datasetColumns: action.payload.columns,
            };
        case actionTypes.SETVIEWCOLUMNS:
            return {
                ...state,
                viewColumns: action.payload.columns,
            };
        case actionTypes.SETREPORTOUTPUT:
            return {
                ...state,
                reportOutput: action.payload.output,
            };
        case actionTypes.SETREPORTPREVIEW:
            return {
                ...state,
                reportPreview: action.payload.preview,
            };
        case actionTypes.SETSAVEDREPORTSLIST:
            return {
                ...state,
                savedReportsList: action.payload.list,
            };
        case actionTypes.SETSELECTEDDATASET:
            return {
                ...state,
                selectedDataset: action.payload.dataset,
            };
        case actionTypes.SETSELECTEDCOLUMNS:
            return {
                ...state,
                selectedColumns: action.payload.columns,
            };
        case actionTypes.SETREPORTCONFIG:
            return {
                ...state,
                reportConfig: action.payload.config,
            };
        case actionTypes.SETPUBLISHEDREPORT:
            return {
                ...state,
                publishedReport: action.payload.report,
            };
        case actionTypes.SETCOLUMNFORMATTING:
            return {
                ...state,
                columnFormatting: action.payload.formatting,
                columnFormattingSaving: false,
            };
        case actionTypes.SETCOLUMNFORMATTINGSAVING:
            return {
                ...state,
                columnFormattingSaving: action.payload.saving,
            };
        case actionTypes.SETCUSTOMREPORTSLIST:
            return {
                ...state,
                customReportsList: action.payload.list,
                customReportsPagination: action.payload.pagination || state.customReportsPagination,
            };
        case actionTypes.SETREPORTDETAILS:
            return {
                ...state,
                reportDetails: action.payload.report,
            };
        case actionTypes.SETUPDATEDREPORT:
            return {
                ...state,
                updatedReport: action.payload.report,
            };
        case actionTypes.SETREPORTPARAMETERS:
            return {
                ...state,
                reportParameters: action.payload.parameters,
                reportParametersLoading: false,
            };
        case actionTypes.SETUSERSFORSHARE:
            return {
                ...state,
                usersForShare: action.payload.list,
            };
        case actionTypes.SETROLESFORSHARE:
            return {
                ...state,
                rolesForShare: action.payload.list,
            };
        case actionTypes.SETSHAREDREPORT:
            return {
                ...state,
                sharedReport: action.payload.data,
                shareReportSaving: false,
            };
        case actionTypes.SETSHAREREPORTSAVING:
            return {
                ...state,
                shareReportSaving: action.payload.saving,
            };
        case actionTypes.SETREPORTSHARES:
            return {
                ...state,
                reportShares: action.payload.shares,
                reportSharesPagination: action.payload.pagination,
            };
        case actionTypes.SETUPDATEDREPORTSHARE:
            return {
                ...state,
                updatedReportShare: action.payload.data,
                updateReportShareSaving: false,
            };
        case actionTypes.SETUPDATEREPORTSHARESAVING:
            return {
                ...state,
                updateReportShareSaving: action.payload.saving,
            };
        case actionTypes.SETDELETEDREPORTSHARE:
            return {
                ...state,
                deletedReportShareId: action.payload.shareId,
                deleteReportShareSaving: false,
            };
        case actionTypes.SETDELETEREPORTSHARESAVING:
            return {
                ...state,
                deleteReportShareSaving: action.payload.saving,
            };
        case actionTypes.RESETCUSTOMREPORTSSTATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default customReportsReducer;